var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"rounded":"","bottom":"","left":"","offset-y":"","content-class":"we-notification"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var attrs = ref.attrs;
var on = ref.on;
return [_c('div',_vm._g(_vm._b({staticClass:"menu-btn"},'div',attrs,false),on),[_vm._t("action")],2)]}}],null,true)},[_c('v-list',[_c('div',{staticClass:"header"},[_vm._v("Notificações")]),_vm._t("notification")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }